import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

// Every account with ledger activity in the year: sales, platform fee and
// the house profit estimate. Sorted by total profit, highest first.
export const GET_REVENUE_BY_ACCOUNT = gql`
  query GetRevenueByAccount($input: GetRevenueByAccountInput!) {
    getRevenueByAccountV2(input: $input) {
      account_id
      name
      events_held
      app_sales
      pos_card_sales
      pos_cash_sales
      platform_fee
      app_profit
      pos_profit
      total_profit
    }
  }
`;

export function useGetRevenueByAccount(year) {
  const { data, loading, error } = useQuery(GET_REVENUE_BY_ACCOUNT, {
    variables: { input: { year } },
    fetchPolicy: 'no-cache',
    skip: !year,
  });

  return { data, loading, error };
}
